import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { actionResetData, actionGetData } from 'modules/Countries/actions'

export const useCountries = () => {
  const dispatch = useDispatch()

  const getData = useCallback((props) => {
    dispatch(actionGetData(props))
  }, [])

  const resetData = useCallback((props) => {
    dispatch(actionResetData(props))
  }, [])

  return { getData, resetData }
}
